var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#3282C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 24.9999C33.7505 25.2121 33.6961 25.4208 33.5921 25.6058C33.488 25.7907 33.3379 25.9456 33.1562 26.0554L21.9 32.9413C21.7102 33.0575 21.4929 33.121 21.2704 33.1251C21.0479 33.1292 20.8283 33.0738 20.6344 32.9647C20.4423 32.8573 20.2822 32.7007 20.1708 32.5109C20.0593 32.3212 20.0003 32.1051 20 31.8851V18.1147C20.0003 17.8947 20.0593 17.6786 20.1708 17.4889C20.2822 17.2991 20.4423 17.1425 20.6344 17.0351C20.8283 16.926 21.0479 16.8706 21.2704 16.8747C21.4929 16.8788 21.7102 16.9423 21.9 17.0585L33.1562 23.9444C33.3379 24.0542 33.488 24.2091 33.5921 24.394C33.6961 24.579 33.7505 24.7877 33.75 24.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/PlayButton.92c95bfb62b5702ca5ba141b1b81f183.svg";
export { ForwardRef as ReactComponent };